export default __webpack_public_path__ + "static/petlove-74d04416e393e21a03fe8a61a781279f.jpg";